import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import {
  IDENTIALERT_SUBSCRIPTION_YEARLY,
  IDENTIALERT_SUBSCRIPTION_MONTHLY,
  IDENTIALERT_SUBSCRIPTION_ADESTRA_TAG,
  IDENTIBASE_PLUS_SUBSCRIPTION,
  IDENTIBASE_PLUS_SUBSCRIPTION_ADESTRA_TAG,
  IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS,
  IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_ADESTRA_TAG,
  TRANSFER_OF_KEEPERSHIP_BREEDER,
  TRANSFER_OF_KEEPERSHIP_BREEDER_ADESTRA_TAG,
  TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT,
  TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_ADESTRA_TAG,
  FOUR_WEEKS_FREE_EMAIL_ADESTRA_TAG,
  UNIDENTIFIED_SUBSCRIPTION_ADESTRA_TAG,
  IDENTIBASE_PLUS_SUBSCRIPTION_ID,
  IDENTIBASE_PLUS_SUBSCRIPTION_NAME,
  IDENTIBASE_PLUS_SUBSCRIPTION_PRICE,
  IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_ID,
  IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_NAME,
  IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_PRICE_PER_YEAR,
  IDENTIALERT_SUBSCRIPTION_ID,
  IDENTIALERT_SUBSCRIPTION_NAME,
  IDENTIALERT_SUBSCRIPTION_PRICE_PER_MONTH,
  IDENTIALERT_SUBSCRIPTION_PRICE_PER_YEAR,
  UNIDENTIFIED_SUBSCRIPTION_ID,
  UNIDENTIFIED_SUBSCRIPTION_NAME,
  UNIDENTIFIED_SUBSCRIPTION_PRICE,
  TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_ID,
  TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_NAME,
  TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_PRICE,
  TRANSFER_OF_KEEPERSHIP_BREEDER_ID,
  TRANSFER_OF_KEEPERSHIP_BREEDER_NAME,
  TRANSFER_OF_KEEPERSHIP_BREEDER_PRICE,
  FOUR_WEEKS_FREE_EMAIL_ID,
  FOUR_WEEKS_FREE_EMAIL_NAME,
  FOUR_WEEKS_FREE_EMAIL_PRICE,
  SMART_TAG_SUBSCRIPTION,
  SMART_TAG_SUBSCRIPTION_ID,
  SMART_TAG_SUBSCRIPTION_NAME,
  SMART_TAG_SUBSCRIPTION_PRICE,
  SMART_TAG_PHYSICAL_TAG,
  PETLOG_SECURE_SUBSCRIPTION,
  PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS,
  PETLOG_REUNITE_SUBSCRIPTION,
  PETLOG_SECURE_SUBSCRIPTION_ID,
  PETLOG_SECURE_SUBSCRIPTION_NAME,
  PETLOG_SECURE_SUBSCRIPTION_PRICE,
  PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS_ID,
  PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS_NAME,
  PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS_PRICE,
  PETLOG_REUNITE_SUBSCRIPTION_ID,
  PETLOG_REUNITE_SUBSCRIPTION_NAME,
  PETLOG_REUNITE_SUBSCRIPTION_PRICE,
  PETLOG_REUNITE_OVERSEAS,
  PETLOG_REUNITE_OVERSEAS_ID,
  PETLOG_REUNITE_OVERSEAS_NAME,
  PETLOG_REUNITE_OVERSEAS_PRICE
} from 'src/app/constants/app.constants';
import { User } from 'src/app/interfaces/user';
import { MemberShipOptionsService } from 'src/app/services/membership-options/membership-options.service';
import { environment } from 'src/environments/environment';
import { IterableService } from 'src/app/services/iterable/iterable.service';
import { UserService } from 'src/app/services/user/user.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';
import { RegistrationFlowService } from 'src/app/services/registration-flow/registration-flow.service';
import { RegistrationFlowStep } from 'src/app/constants/registration-flow.constants';

// Long enough to read the four rebranded confirmation lines before the page redirects on its
// own. Anything still showing the single-line message keeps the original delay.
const REBRANDED_REDIRECT_DELAY_MS = 8000;
const REDIRECT_DELAY_MS = 3000;

@Component({
  selector: 'app-identibase-sub-appreciation',
  templateUrl: './identibase-sub-appreciation.component.html',
})
export class IdentibaseSubAppreciationComponent implements OnInit, AfterViewInit, OnDestroy {
  public subAdestraTag: string;
  private subId: string;
  private subName: string;
  private subPrice: number;
  public navRoute: string;
  public isAdestraTagReady: boolean = false;
  private chipNumber: string | undefined;
  private vetCode: string | undefined;
  public thankYouMessage: string = 'Thank you for your purchase!';
  public isRebranded: boolean = false;
  public showRebrandedMessage: boolean = false;
  private isSmartTagPurchase: boolean = false;
  private isBasicUser: boolean = false;
  private isBrowser: boolean;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _gtmService: GoogleTagManagerService,
    private _membershipOptionsService: MemberShipOptionsService,
    private iterableService: IterableService,
    private userService: UserService,
    private featureFlags: FeatureFlagsService,
    private registrationFlowService: RegistrationFlowService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isRebranded = this.featureFlags.isEnabled('useRebrandedLayout');
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    const queryParams = this._activatedRoute.snapshot.queryParams;
    const user = this._activatedRoute.snapshot.data.user;
    const isUpgrade = queryParams.isUpgrade?.toLowerCase() === 'true';

    this.isBasicUser = this.userService.isUserBasic(user.productType);

    if (queryParams && queryParams.subscriptionType) {
      this.setSubAdestraTagAndNavRoute(queryParams);
      this.pushGTMTag(user, isUpgrade);
    } else {
      this.subAdestraTag = UNIDENTIFIED_SUBSCRIPTION_ADESTRA_TAG;
      this.navRoute = '/dashboard';
    }

    const isPurchaseMessage = queryParams.subscriptionType !== 'petplan4weeksfree';

    this.showRebrandedMessage = this.isRebranded && isPurchaseMessage && this.isSmartTagPurchase;

    if (!isPurchaseMessage) {
      this.thankYouMessage = 'Your pet’s microchip registration is now complete.';
    } else if (this.showRebrandedMessage) {
      this.thankYouMessage = 'Thanks for your purchase';
    }

    this.isAdestraTagReady = true;

    this.iterableService.trackConversion(
      user.id,
      user.contact.email,
      [
        {
          id: this.subId,
          name: this.subName,
          price: this.subPrice,
          quantity: 1
        }
      ],
      this.subPrice
    );

  }

  ngAfterViewInit() {
    setTimeout(() => {
      switch (this.navRoute) {
        case '/dashboard':
          if (this.subAdestraTag === TRANSFER_OF_KEEPERSHIP_BREEDER_ADESTRA_TAG) {
            // B21K keepers go on to their welcome gift step. The backend skips it for
            // ineligible keepers, and the welcome gift page redirects them too.
            if (
              this.registrationFlowService.isB21KFlow() &&
              !this.registrationFlowService.isStepCompleted(RegistrationFlowStep.WelcomeGift)
            ) {
              this._router.navigate(['/welcome-gift']);
              break;
            }
            this._router.navigate([this.navRoute], { queryParams: { tokExplore: 'open' } });
            break;
          }
          this.navigateToDashboardOrPetPlan(this.navRoute);
          break;
        case '/rehome-pet':
          this._router.navigate([this.navRoute], {
            queryParams: { chipNumber: this.chipNumber, vetCode: this.vetCode },
          });
          break;
        default:
          this._router.navigate([this.navRoute]);
      }
    }, this.showRebrandedMessage ? REBRANDED_REDIRECT_DELAY_MS : REDIRECT_DELAY_MS);
  }

  ngOnDestroy(): void {
    if (this.isBrowser) {
      localStorage.removeItem("arrived_from_email");
    }
  }

  // Reads the steps the route resolved on arrival
  private navigateToDashboardOrPetPlan(navRoute: string) {
    if (
      this.registrationFlowService.isStepCompleted(RegistrationFlowStep.MembershipOptions) &&
      !this.registrationFlowService.isStepCompleted(RegistrationFlowStep.WelcomeGift)
    ) {
      return this._router.navigate(['/welcome-gift']);
    }
    return this._router.navigate([navRoute], { queryParams: { followUs: 'open' } });
  }

  private setSubAdestraTagAndNavRoute(queryParams: Params) {
    const subscriptionType = queryParams.subscriptionType;
    const petId = queryParams.petId;
    const chipNumber = queryParams.chipNumber;
    const vetCode = queryParams.vetCode;

    switch (subscriptionType) {
      case IDENTIBASE_PLUS_SUBSCRIPTION:
        this.subAdestraTag = IDENTIBASE_PLUS_SUBSCRIPTION_ADESTRA_TAG;
        this.subId = IDENTIBASE_PLUS_SUBSCRIPTION_ID;
        this.subName = IDENTIBASE_PLUS_SUBSCRIPTION_NAME;
        this.subPrice = IDENTIBASE_PLUS_SUBSCRIPTION_PRICE;
        this.navRoute = '/dashboard';
        break;
      case IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS:
        this.subAdestraTag = IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_ADESTRA_TAG;
        this.subId = IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_ID;
        this.subName = IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_NAME;
        this.subPrice = IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_PRICE_PER_YEAR;
        this.navRoute = '/account/user-details';
        break;
      case IDENTIALERT_SUBSCRIPTION_YEARLY:
        this.subAdestraTag = IDENTIALERT_SUBSCRIPTION_ADESTRA_TAG;
        this.subId = IDENTIALERT_SUBSCRIPTION_ID;
        this.subName = IDENTIALERT_SUBSCRIPTION_NAME;
        this.subPrice = IDENTIALERT_SUBSCRIPTION_PRICE_PER_YEAR;
        this.navRoute = '/dashboard';
        break;
      case IDENTIALERT_SUBSCRIPTION_MONTHLY:
        this.subAdestraTag = IDENTIALERT_SUBSCRIPTION_ADESTRA_TAG;
        this.subId = IDENTIALERT_SUBSCRIPTION_ID;
        this.subName = IDENTIALERT_SUBSCRIPTION_NAME;
        this.subPrice = IDENTIALERT_SUBSCRIPTION_PRICE_PER_MONTH;
        this.navRoute = '/dashboard';
        break;
      case TRANSFER_OF_KEEPERSHIP_BREEDER:
        this.subAdestraTag = TRANSFER_OF_KEEPERSHIP_BREEDER_ADESTRA_TAG;
        this.subId = TRANSFER_OF_KEEPERSHIP_BREEDER_ID;
        this.subName = TRANSFER_OF_KEEPERSHIP_BREEDER_NAME;
        this.subPrice = TRANSFER_OF_KEEPERSHIP_BREEDER_PRICE;
        this.navRoute = '/dashboard';
        break;
      case TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT:
        this.subAdestraTag = TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_ADESTRA_TAG;
        this.subId = TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_ID;
        this.subName = TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_NAME;
        this.subPrice = TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_PRICE;

        if (chipNumber && vetCode) {
          this.navRoute = `/rehome-pet`;
          this.chipNumber = chipNumber;
          this.vetCode = vetCode;
        } else {
          this.navRoute = '/dashboard';
        }
        break;

      case SMART_TAG_SUBSCRIPTION:
        this.subId = SMART_TAG_SUBSCRIPTION_ID;
        this.subName = SMART_TAG_SUBSCRIPTION_NAME;
        this.subPrice = SMART_TAG_SUBSCRIPTION_PRICE;
        this.isSmartTagPurchase = true;
        this.navRoute = '/dashboard';
        break;

      case SMART_TAG_PHYSICAL_TAG:
        this.navRoute = '/dashboard';
        break;

      case 'petplan4weeksfree':
        this.subAdestraTag = FOUR_WEEKS_FREE_EMAIL_ADESTRA_TAG;
        this.subId = FOUR_WEEKS_FREE_EMAIL_ID;
        this.subName = FOUR_WEEKS_FREE_EMAIL_NAME;
        this.subPrice = FOUR_WEEKS_FREE_EMAIL_PRICE;
        this.navRoute = '/dashboard';
        break;

      // Petlog related cases
      case PETLOG_SECURE_SUBSCRIPTION:
        this.subId = PETLOG_SECURE_SUBSCRIPTION_ID;
        this.subName = PETLOG_SECURE_SUBSCRIPTION_NAME;
        this.subPrice = PETLOG_SECURE_SUBSCRIPTION_PRICE;
        this.navRoute = '/dashboard';
        break;
      case PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS:
        this.subId = PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS_ID;
        this.subName = PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS_NAME;
        this.subPrice = PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS_PRICE;
        this.navRoute = '/account/user-details';
        break;
      case PETLOG_REUNITE_SUBSCRIPTION:
        this.subId = PETLOG_REUNITE_SUBSCRIPTION_ID;
        this.subName = PETLOG_REUNITE_SUBSCRIPTION_NAME;
        this.subPrice = PETLOG_REUNITE_SUBSCRIPTION_PRICE;
        this.navRoute = '/dashboard';
        break;
      case PETLOG_REUNITE_OVERSEAS:
        this.subId = PETLOG_REUNITE_OVERSEAS_ID;
        this.subName = PETLOG_REUNITE_OVERSEAS_NAME;
        this.subPrice = PETLOG_REUNITE_OVERSEAS_PRICE;
        this.navRoute = '/dashboard';
        break;

      default:
        this.subAdestraTag = UNIDENTIFIED_SUBSCRIPTION_ADESTRA_TAG;
        this.subId = UNIDENTIFIED_SUBSCRIPTION_ID;
        this.subName = UNIDENTIFIED_SUBSCRIPTION_NAME;
        this.subPrice = UNIDENTIFIED_SUBSCRIPTION_PRICE;
        this.navRoute = '/dashboard';
    }
  }

  private pushGTMTag(user: User, isUpgrade: boolean) {
    if (!isUpgrade || !environment.googleTagManagerId || !environment.conversionSendToParam) return;

    const productName = this._membershipOptionsService.getUserMembershipAnalyticsName(user);

    this._gtmService.pushTag({
      event: 'conversion',
      send_to: environment.conversionSendToParam,
      product_name: productName,
      environment: environment.name
    }).catch(() => {});

  }
}
